export default "__VITE_ASSET__7370cce7__"